<script setup lang="ts">
import type { Child } from 'src/modules/Child/models/Child';
import ChildDetailsCard from '../ChildDetailsCard/ChildDetailsCard.vue';

interface Props {
  selectedChildForLicense: Child | null;
  processingLicense: boolean;
}
defineProps<Props>();

const children = defineModel<Child[]>('children');

const emits = defineEmits<{
  editChild: [Child];
  deleteChild: [Child];
  toggleActive: [Child];
  loginToken: [Child];
  checkout: [Child];
}>();
</script>

<template>
  <q-list>
    <div class="row">
      <q-item
        v-for="child in children"
        :key="child.id"
        class="q-my-md col-lg-4 col-md-6 col-xs-12"
      >
        <q-item-section>
          <ChildDetailsCard
            :child="child"
            class="rounded-borders-xl shadow-card-dark"
            :processing-license="
              processingLicense && selectedChildForLicense?.id === child.id
            "
            dark
            @edit-child="emits('editChild', child)"
            @delete-child="emits('deleteChild', child)"
            @toggle-active="emits('toggleActive', child)"
            @login-token="emits('loginToken', child)"
            @checkout="emits('checkout', child)"
          />
        </q-item-section>
      </q-item>
    </div>
  </q-list>
</template>
